import { css, cx } from '@eti/styles';
import { vars } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const wallStyles = {
  base: css`
    width: 5px;
  `,
  backgroundColor: {
    default: css`
      background-color: ${vars.colors.inputs.border};
    `,
    empty: css`
      background-color: transparent;
    `
  },
  margin: {
    left: {
      normal: css`
        margin-left: 30px;
      `,
      overWing: css`
        margin-left: 0;
      `,
      noDirection: css`
        margin-left: 10px;
      `
    },
    right: {
      normal: css`
        margin-right: 30px;
      `,
      overWing: css`
        margin-right: 0;
      `,
      noDirection: css`
        margin-right: 10px;
      `
    }
  }
};
const Wall = ({
  isEmptyRow,
  isLeft,
  isOverWing,
  isRight
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: cx(wallStyles.base, {
      [wallStyles.backgroundColor.default]: !isEmptyRow,
      [wallStyles.backgroundColor.empty]: isEmptyRow,
      [wallStyles.margin.left.noDirection]: !isLeft,
      [wallStyles.margin.left.normal]: isLeft && !isOverWing,
      [wallStyles.margin.left.overWing]: isLeft && isOverWing,
      [wallStyles.margin.right.noDirection]: !isRight,
      [wallStyles.margin.right.normal]: isRight,
      [wallStyles.margin.right.overWing]: isRight && isOverWing
    }),
    "data-testid": isLeft ? 'leftWall' : 'rightWall'
  });
};
export default Wall;
//# sourceMappingURL=Wall.js.map